import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { AuthChannelType } from '@hotelplan/fdr.lib.ident.auth-config';
import { useAuthentication } from '@hotelplan/fdr.lib.ident.with-auth';
import { FdrPageComponents } from 'components/domain/fdr-page-components';
import { trackBookmarkPage } from 'components/domain/tracking/bookmarkTracking';
import { fdrBookmarkPageComponentsVars } from 'components/page/bookmark/bookmark.vars';
import { useFdrBookmarkPageComponentsQuery } from 'schemas/query/bookmark/fdr-bookmark-page-components.generated';
import { useFdrBookmarkPageQuery } from 'schemas/query/bookmark/fdr-bookmark-page.generated';
import { useBookmarkContext } from './context/fdr-bookmark-context';
import FdrBookmarkItemsWrapper from './fdr-bookmark-items-wrapper';

const BookmarkContentWrap = styled.div(({ theme: { media, space } }) => ({
  maxWidth: '1480px',
  margin: '0 auto',
  paddingLeft: '20px',
  paddingRight: '20px',
  paddingTop: '154px',
  [media.mobile]: {
    paddingLeft: space[3],
    paddingRight: space[3],
  },
}));

const FdrBookmarkPageContent: React.FC = () => {
  const { data: data } = useFdrBookmarkPageQuery();
  const { data: componentsData } = useFdrBookmarkPageComponentsQuery({
    variables: fdrBookmarkPageComponentsVars,
  });

  const { title, text, buttonText, buttonLink } = data?.fdrBookmarksPage || {};

  const { channelType } = useAuthentication();
  const isB2B = channelType === AuthChannelType.B2B;

  const { initialized, count, bookmarkGroups } = useBookmarkContext();
  const [t, { language }] = useTranslation();

  useEffect(() => {
    if (initialized) {
      trackBookmarkPage(language, count);
    }
  }, [initialized]);

  return (
    <>
      <BookmarkContentWrap>
        <FdrBookmarkItemsWrapper
          title={
            isB2B
              ? t('bookmark:b2b.pageTitle', { count: bookmarkGroups.length })
              : title
          }
          main={text}
          buttonLink={buttonLink}
          buttonText={buttonText}
        />
      </BookmarkContentWrap>
      <FdrPageComponents
        components={
          componentsData?.fdrBookmarksPage?.pageComponents?.components
        }
      />
    </>
  );
};

export default FdrBookmarkPageContent;
